import { useNavigate } from "react-router-dom"
import { Modal, ModalId, useUIActions } from "../../../../../features/ui"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { CustomerType } from "../../../state/types"

interface Props {
    customerType?: CustomerType
}

export const EditCustomerTypeModal = ({ customerType }: Props) => {
    const navigate = useNavigate()
    const { getRoutePath } = useRoutesHooks()
    const { closeModal } = useUIActions()

    const handleManual = () => {
        closeModal(ModalId.EDIT_CUSTOMER_TYPE)
        if (customerType) navigate(`${getRoutePath(RoutePath.CUSTOMER_TYPES, customerType.id)}/${RoutePath.EDIT}`)
    }

    const handleImport = () => {
        closeModal(ModalId.EDIT_CUSTOMER_TYPE)
        if (customerType) {
            const basePath = getRoutePath(RoutePath.CUSTOMER_TYPES)
            navigate(`${basePath}/${RoutePath.IMPORT}/${customerType.id}`)
        }
    }

    return (
        <Modal
            modalId={ModalId.EDIT_CUSTOMER_TYPE}
            title={`Editar Lista de Precios: ${customerType?.name || ''}`}
            widthSize="s"
            actions={[
                { label: 'Editar Manualmente', kind: 'primary', onClick: handleManual },
                { label: 'Importar Archivo', kind: 'tertiary', onClick: handleImport }
            ]}
        >
            <p>Seleccione cómo desea editar los valores de esta lista de precios.</p>
        </Modal>
    )
}
